import { useState } from 'react';
import { ChevronDown, TrendingUp } from 'lucide-react';
import WhySafe from './WhySafe';

const pct = (p) => `${Math.round(p * 100)}%`;

// College "Blowout Spreads": powerhouse favorites the stats say can cover a big line. Riskier than straight wins.
export default function BlowoutSpreads({ spreads }) {
  const [open, setOpen] = useState(false);
  if (!spreads?.length) return null;
  return (
    <div className="rounded-lg border border-orange-500/30 bg-zinc-900/60" data-testid="blowout-spreads">
      <button type="button" onClick={() => setOpen((o) => !o)} className="w-full flex items-center gap-2 px-3 py-2.5 text-left" data-testid="blowout-spreads-toggle">
        <ChevronDown className={`w-4 h-4 text-zinc-500 transition-transform ${open ? 'rotate-180' : ''}`} />
        <TrendingUp className="w-4 h-4 text-orange-300" />
        <span className="flex-1 text-sm font-semibold text-white">Blowout Spreads <span className="text-zinc-400 font-normal">· {spreads.length} picks</span></span>
      </button>
      {open && (
        <div className="px-3 pb-2" data-testid="blowout-spreads-list">
          <p className="text-[10px] text-zinc-500 mb-1">Spreads are riskier than straight wins — keep them off your safest tickets.</p>
          {spreads.map((x, i) => (
            <div key={x.event_id} className="flex items-start gap-2 py-1.5 border-b border-zinc-800/70 last:border-0" data-testid={`blowout-spread-${i}`}>
              {x.logo && <img src={x.logo} alt="" className="w-5 h-5 rounded-full bg-white/90 p-[1px] object-contain shrink-0" />}
              <div className="min-w-0 flex-1">
                <p className="text-sm font-semibold text-white">{x.line} {x.power_vs_small && <span className="ml-1 rounded bg-orange-500 px-1 text-[9px] font-bold text-black">POWERHOUSE</span>}</p>
                <p className="text-[11px] text-zinc-500">{x.game}</p>
                <WhySafe lines={x.why} testId={`blowout-spread-${i}-why`} />
              </div>
              <span className="shrink-0 rounded-md border border-orange-500/40 bg-orange-500/15 px-1.5 py-0.5 font-mono text-xs font-bold text-orange-300">{pct(x.cover)}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
